export default {
  badge: '배지',
  open: '열기',
  close: '닫기',
  dismiss: '닫기',
  confirmEdit: {
    ok: '확인',
    cancel: '취소',
  },
  dataIterator: {
    noResultsText: '일치하는 항목이 없습니다.',
    loadingText: '불러오는 중...',
  },
  dataTable: {
    itemsPerPageText: '페이지 당 행 수:',
    ariaLabel: {
      sortDescending: '내림차순 정렬.',
      sortAscending: '오름차순 정렬.',
      sortNone: '정렬하지 않음.',
      activateNone: '정렬을 취소하려면 활성화하세요.',
      activateDescending: '내림차순 정렬을 위해 활성화하세요.',
      activateAscending: '오름차순 정렬을 위해 활성화하세요.',
    },
    sortBy: '정렬 기준',
  },
  dataFooter: {
    itemsPerPageText: '페이지 당 항목 수:',
    itemsPerPageAll: '전체',
    nextPage: '다음 페이지',
    prevPage: '이전 페이지',
    firstPage: '첫 페이지',
    lastPage: '마지막 페이지',
    pageText: '{2} 중 {0}-{1}',
  },
  dateRangeInput: {
    divider: '부터',
  },
  datePicker: {
    itemsSelected: '{0}개 선택됨',
    range: {
      title: '날짜 선택',
      header: '날짜 입력',
    },
    title: '날짜 선택',
    header: '날짜 입력',
    input: {
      placeholder: '날짜 입력',
    },
  },
  noDataText: '데이터가 없습니다.',
  carousel: {
    prev: '이전 화면',
    next: '다음 화면',
    ariaLabel: {
      delimiter: '캐러셀 슬라이드 {0} / {1}',
    },
  },
  calendar: {
    moreEvents: '{0} 더보기',
    today: '오늘',
  },
  input: {
    clear: '{0} 지우기',
    prependAction: '{0} 앞에 추가된 동작',
    appendAction: '{0} 뒤에 추가된 동작',
    otp: 'OTP 문자 {0}를 입력하세요',
  },
  fileInput: {
    counter: '{0}개 파일',
    counterSize: '{0}개 파일 (총 {1})',
  },
  fileUpload: {
    title: '파일을 여기에 드래그 앤 드롭하세요',
    divider: '또는',
    browse: '파일 찾기',
  },
  timePicker: {
    am: '오전',
    pm: '오후',
    title: '시간을 선택하세요',
  },
  pagination: {
    ariaLabel: {
      root: '페이지 탐색',
      next: '다음 페이지',
      previous: '이전 페이지',
      page: '{0} 페이지로 이동',
      currentPage: '현재 페이지, 페이지 {0}',
      first: '첫 페이지',
      last: '마지막 페이지',
    },
  },
  stepper: {
    next: '다음',
    prev: '이전',
  },
  rating: {
    ariaLabel: {
      item: '{1} 중 {0} 점',
    },
  },
  loading: '불러오는 중...',
  infiniteScroll: {
    loadMore: '더 불러오기',
    empty: '더 이상 항목이 없습니다',
  },
  rules: {
    required: '이 필드는 필수입니다',
    email: '유효한 이메일을 입력해주세요',
    number: '이 필드는 숫자만 포함할 수 있습니다',
    integer: '이 필드는 정수만 포함할 수 있습니다',
    capital: '이 필드는 대문자만 포함할 수 있습니다',
    maxLength: '최대 {0}자를 입력해야 합니다',
    minLength: '최소 {0}자를 입력해야 합니다',
    strictLength: '입력한 필드의 길이가 유효하지 않습니다',
    exclude: '{0} 문자는 허용되지 않습니다',
    notEmpty: '최소 하나의 값을 선택해주세요',
    pattern: '형식이 유효하지 않습니다',
  },
  hotkey: {
    then: '그 다음',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: '위쪽 화살표',
    downArrow: '아래쪽 화살표',
    leftArrow: '왼쪽 화살표',
    rightArrow: '오른쪽 화살표',
    backspace: '백스페이스',
    space: '스페이스',
    plus: '플러스',
    shortcut: '키보드 단축키: {0}',
  },
}
